import { Reducer } from "redux";

import { StoreFilterDataResponse } from "../models/Api/StoreFilterData";
import { StoreFilterDataDispatchTypes } from "../constants/StoreFilterData";
import { StoreFilterDataActionDispatchTypes } from "../models/DispatchTypes/StoreFilterData";

const initialState: StoreFilterDataResponse = {
  loading: false,
  data: {
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    subscriberId: "",
    }
};

const StoreFilterDataReducer: Reducer<
  StoreFilterDataResponse,
  StoreFilterDataActionDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case StoreFilterDataDispatchTypes.STORE_FILTER_INFORMATION_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case StoreFilterDataDispatchTypes.STORE_FILTER_INFORMATION_SUCCESS: {
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    }
  }
  return state;
};

export default StoreFilterDataReducer;